<div class="file-upload" [class.drag-over]="isDragEnter" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <i class="fas fa-upload"></i>

  <!-- BEFORE CHOICE -->
  @if (flowState === FLOW_STATE.UNSELECTED) {
    <label class="btn file-upload-label">
      <input type="file" class="d-none" (change)="onChangeFileInput($event.target.files)" [disabled]="disabled">
      <span class="file-upload-text">{{'component.uploadFile.choseFile' | translate}}</span>
    </label>
    <!-- feedback -->
    @if (msgType === MSG_TYPE_ENUM.SUCCESS) {
      <span class="alert alert-success file-upload-feedback">{{'component.uploadFile.success' | translate}}</span>
    }
  } @else {
    <!-- loading -->
    @if (loadingModel.isLoading) {
      <span class="ui-loading" [model]="loadingModel"></span>
    } @else {
      <!-- button -->
      <button class="btn file-upload-btn" (click)="onClickBtn()">
        <span class="file-upload-text">{{'component.uploadFile.uploadFile' | translate}}</span>
      </button>
      <!-- feedback -->
      @if (msgType === MSG_TYPE_ENUM.ERROR) {
        <span class="alert alert-danger file-upload-feedback">{{'component.uploadFile.error' | translate}}</span>
      }
      <!-- info file -->
      <a href="javascript:void(0);" class="file-upload-info-file" (click)="onRemoveFile(false)">
        <span class="file-upload-info-file-text">{{file.name}}</span>
        <i class="fas fa-trash file-upload-info-file-icon"></i>
      </a>
    }
    <!-- content -->
  }

  <!-- AFTER CHOICE -->
</div>
